import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Traducción de una entrada del menu
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class MenuEntryTranslation {
    public title = ''

    constructor (public locale: string) {}

    public static deserialize (data: KeyValuePair) {
        const translation = new this(data.locale || '')
        translation.title = data.title

        return translation
    }
}
